import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';

@Component({
  selector: 'app-checkbox-group',
  templateUrl: './checkbox-group.component.html',
  styleUrls: ['./checkbox-group.component.sass']
})
export class CheckboxGroupComponent implements OnInit {
  @Input() config: IFieldConfig;
  @Input() group: FormGroup;
  @Input() typeCes?: TypeCesEnum | undefined;

  // FormGroup interno para gerenciar os checkboxes individuais
  checkboxForm: FormGroup;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.checkboxForm = this.fb.group({});
    // Adiciona um FormControl para cada opção no grupo interno
    this.config.options?.forEach(option => {
      this.checkboxForm.addControl(option.value, this.fb.control(false)); // Inicializa como desmarcado
    });

    // Sincroniza o valor do FormGroup interno com o FormControl principal
    this.checkboxForm.valueChanges.subscribe(value => {
      this.group.get(this.config.name)?.setValue(value);
    });

    // Define o valor inicial se já existir no FormGroup principal
    const initialValue = this.group.get(this.config.name)?.value;
    if (initialValue && typeof initialValue === 'object') {
      this.checkboxForm.patchValue(initialValue, { emitEvent: false }); // emitEvent: false para evitar loop inicial
    }

     // Desabilita se for modo SHOW
     if (this.typeCes === TypeCesEnum.SHOW) {
       this.checkboxForm.disable();
     }
  }

  // Helper para obter o FormControl de uma opção específica
  getCheckboxControl(optionValue: string): FormControl {
    return this.checkboxForm.get(optionValue) as FormControl;
  }
} 